// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__q1Ctg","border":"styles_border__94K04","pointer":"styles_pointer__B4aIe","avatar":"styles_avatar__tVIXD","badge":"styles_badge__lWg3Z"};